export default {
  step8:[
    {
      id:65,
      step: 8,
      tab:1,
      stepJp: "内石",
      name: "1月ガーネット",
      hex: "#BC85BA",
      property: "insideDia",
      val: "uchigawaGarnet",
      option:null,
      summary:"",
      price:7000,//6000,
    },
    {
      id:66,
      step: 8,
      tab:1,
      stepJp: "内石",
      name: "2月アメジスト",
      hex: "#BC97C9",
      property: "insideDia",
      val: "uchigawaAmethyst",
      option:null,
      summary:"",
      price:7000,//6000,
    },
    {
      id:67,
      step: 8,
      tab:1,
      stepJp: "内石",
      name: "3月アクアマリン",
      hex: "#DFF2F4",
      property: "insideDia",
      val: "uchigawaAquamarine",
      option:null,
      summary:"",
      price:7000,//6000,
    },
    {
      id:68,
      step: 8,
      tab:1,
      stepJp: "内石",
      name: "5月エメラルド",
      hex: "#2ecc71",
      property: "insideDia",
      val: "uchigawaEmerald",
      option:null,
      summary:"",
      price:7000,//6000,
    },
    {
      id:69,
      step: 8,
      tab:1,
      stepJp: "内石",
      name: "6月ムーンストーン",
      hex: "#E6E6E6",
      property: "insideDia",
      val: "uchigawaMoonstone",
      option:null,
      summary:"",
      price:7000,//6000,
    },
    {
      id:71,
      step: 8,
      tab:1,
      stepJp: "内石",
      name: "7月ルビー",
      hex: "#C97074",
      property: "insideDia",
      val: "uchigawaRuby",
      option:null,
      summary:"",
      price:7000,//6000,
    },
    {
      id:72,
      step: 8,
      tab:1,
      stepJp: "内石",
      name: "8月ペリドット",
      hex: "#8AA59C",
      property: "insideDia",
      val: "uchigawaPeridot",
      option:null,
      summary:"",
      price:7000,//6000,
    },
    {
      id:73,
      step: 8,
      tab:1,
      stepJp: "内石",
      name: "9月サファイヤ",
      hex: "#333333",
      property: "insideDia",
      val: "uchigawaSapphire",
      option:null,
      summary:"",
      price:7000,//6000,
    },
    {
      id:74,
      step: 8,
      tab:1,
      stepJp: "内石",
      name: "10月ピンクトリマリン",
      hex: "#FFD1F4",
      property: "insideDia",
      val: "uchigawaTourmaline",
      option:null,
      summary:"",
      price:7000,//6000,
    },
    {
      id:75,
      step: 8,
      tab:1,
      stepJp: "内石",
      name: "11月シトリン",
      hex: "#917F5C",
      property: "insideDia",
      val: "uchigawaCitrine",
      option:null,
      summary:"",
      price:7000,//6000,
    },
    {
      id:76,
      step: 8,
      tab:1,
      stepJp: "内石",
      name: "12月タンザナイト",
      hex: "#6C5986",
      property: "insideDia",
      val: "uchigawaTanzanite",
      option:null,
      summary:"",
      price:7000,//6000,
    },
    {
      id:77,
      step: 8,
      tab:2,
      stepJp: "内石",
      name: "ダイヤモンド（透明）",
      hex: "#E6E6E6",
      property: "insideDia",
      val: "uchigawaDiamond",
      option:null,
      summary:"",
      price:8000,//10000,
    },
    {
      id:78,
      step: 8,
      tab:2,
      stepJp: "内石",
      name: "ダイヤモンド（ブルー）",
      hex: "#70A0C9",
      property: "insideDia",
      val: "uchigawaBlueBaseDia",
      option:null,
      summary:"",
      price:8000,//10000,
    },
    {
      id:79,
      step: 8,
      tab:2,
      stepJp: "内石",
      name: "ダイヤモンド（ブラック）",
      hex: "#272727",
      property: "insideDia",
      val: "uchigawaBlackBaseDia",
      option:null,
      summary:"",
      price:8000,//10000,
    },
    {
      id:80,
      step: 8,
      tab:2,
      stepJp: "内石",
      name: "ダイヤモンド（ブラウン）",
      hex: "#74634C",
      property: "insideDia",
      val: "uchigawaBrownBaseDia",
      option:null,
      summary:"",
      price:8000,//10000,
    },
    {
      id:81,
      step: 8,
      tab:2,
      stepJp: "内石",
      name: "デスティニーダイヤモンド（透明）",
      hex: "#E6E6E6",
      property: "insideDia",
      val: "destinyDiamond",
      option:null,
      summary:"1粒のダイヤモンド原石から生まれた2つのダイヤ デスティニーダイヤモンド（DESTINYDIAMOND®）はマリッジリングの内側にお入れすることが可能です。外側留めをご希望の方は、デザインにより可能ですのでご相談ください。",
      price:12000//15000,
    },
  ]
}
